import { IAreaTargetFormationFactor } from '../../interfaces/iarea-target-formation-factor';
import { Area } from '../area';
import { AssetTeam } from '../asset-team';
import { TargetFormation } from '../target-formation';

export class AreaTargetFormationFactorBase {
  AreaTargetFormationFactorId: number;
  AreaId: number;
  TargetFormationId: number;
  AssetTeamId: number;
  Factor: number;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Area?: Area;
  AssetTeam?: AssetTeam;
  TargetFormation?: TargetFormation;

  constructor(item?: IAreaTargetFormationFactor) {
    if (item) {

      this.AreaTargetFormationFactorId = item.AreaTargetFormationFactorId;
      this.AreaId = item.AreaId;
      this.TargetFormationId = item.TargetFormationId;
      this.AssetTeamId = item.AssetTeamId;
      this.Factor = item.Factor;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Area = new Area(item.Area);
      this.AssetTeam = new AssetTeam(item.AssetTeam);
      this.TargetFormation = new TargetFormation(item.TargetFormation);
    }
  }
}